import React, { useState } from 'react';
import { Card, Form, Input, Button, Typography, App, Row, Col, Divider } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../services/supabase';

const { Title, Text } = Typography;

const LoginPage = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { message } = App.useApp();
  
  const onFinish = async (values) => {
    setLoading(true);
    try {
      const { error } = await supabase.auth.signInWithPassword({
        email: values.email,
        password: values.password,
      });
      
      if (error) throw error;
      
      message.success('Login successful!');
      navigate('/dashboard');
    } catch (error) {
      message.error(error.message);
    } finally {
      setLoading(false);
    }
  };
  
  return (
    <Row 
      className="min-h-screen flex flex-col md:flex-row"
      style={{
        position: 'relative',
        overflow: 'hidden'
      }}
    >
      {/* Background Image with Blur */}
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundImage: 'url(/loginbg.jpeg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          filter: 'blur(0px)',
          zIndex: 0
        }}
      />
      
      {/* Login Section */}
      <Col 
        xs={24} 
        className="flex items-center justify-center" 
        style={{ 
          minHeight: '100vh',
          position: 'relative',
          zIndex: 1
        }}
      >
        <div
          style={{ 
            margin: '20px',
            borderRadius: '20px',
            background: 'rgba(255, 255, 255, 0.7)',
            backdropFilter: 'blur(3px)',
            WebkitBackdropFilter: 'blur(25px)',
            border: '1px solid rgba(255, 255, 255, 0.5)',
            boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.2)',
            padding: '48px 32px',
            maxWidth: '400px',
            width: '100%'
          }}
        >
          <div className="text-center mb-6">
            {/* Company Logo */}
            <div className="flex justify-center mb-6">
              <img 
                src="https://dgdxceowybpfmyddckiu.supabase.co/storage/v1/object/public/payroll_logo//mypayroll.png" 
                alt="MyPayroll Logo" 
                style={{ 
                  width: '80px'
                }}
                className="mx-auto"
              />
            </div>
            <Title level={3} className="mb-1 text-xl md:text-2xl" style={{ color: '#1f1f1f' }}>
              Welcome back
            </Title>
            <Text type="secondary" className="text-sm md:text-base" style={{ color: '#3f3f3f' }}>
              Sign in to your account
            </Text>
          </div>
          
          <Form
            name="login"
            initialValues={{ remember: true }}
            onFinish={onFinish}
            layout="vertical"
            size="large"
          >
            <Form.Item
              name="email"
              rules={[{ required: true, message: 'Please enter your email!' }]}
            >
              <Input 
                prefix={<UserOutlined className="text-gray-400" />} 
                placeholder="Email address"
                className="rounded-md py-1"
                size="middle"
                style={{
                  background: 'rgba(255, 255, 255, 0.9)',
                  borderColor: 'rgba(255, 255, 255, 0.5)'
                }}
              />
            </Form.Item>
            
            <Form.Item
              name="password"
              rules={[{ required: true, message: 'Please enter your password!' }]}
            >
              <Input.Password
                prefix={<LockOutlined className="text-gray-400" />}
                placeholder="Password"
                className="rounded-md py-1"
                size="middle"
                style={{
                  background: 'rgba(255, 255, 255, 0.9)',
                  borderColor: 'rgba(255, 255, 255, 0.5)'
                }}
              />
            </Form.Item>
            
            <Form.Item>
              <Button 
                type="primary" 
                htmlType="submit" 
                loading={loading}
                block
                className="h-9 md:h-10 rounded-md"
              >
                Sign in
              </Button>
            </Form.Item>
          </Form>
          
          <Divider plain className="my-6 md:my-8">
            <Text type="secondary" className="text-xs flex items-center justify-center" style={{ color: '#3f3f3f' }}>
              <img 
                src="https://dgdxceowybpfmyddckiu.supabase.co/storage/v1/object/public/payroll_logo//mySmart_Solutions.png" 
                alt="mySmart Solutions Logo" 
                style={{ height: '20px', marginRight: '8px' }}
              />
              Powered by mySmart
            </Text>
          </Divider>
          
          <Text type="secondary" className="text-xs block text-center" style={{ color: '#3f3f3f' }}>
            © 2025 All Rights Reserved
          </Text>
        </div>
      </Col>
    </Row>
  );
};

export default LoginPage;